/**
 * Realm is available in Electron (via preload IPC) or when explicitly enabled
 * for in-memory stub testing in the browser.
 */
export const isElectronRuntime = () => {
  if (typeof window === 'undefined') return false;
  if (window.workloopRealm) return true;
  if (typeof navigator !== 'undefined' && /Electron/i.test(navigator.userAgent || '')) {
    return true;
  }
  try {
    return Boolean(window.process?.versions?.electron);
  } catch {
    return false;
  }
};

export const isRealmEnabled = () => {
  if (typeof window === 'undefined') return false;
  if (isElectronRuntime() && window.workloopRealm) return true;
  return process.env.REACT_APP_REALM_ENABLED === 'true';
};
